















import {Component, Prop, Vue} from 'vue-property-decorator';
import PlanEditMainCard from '@/views/journals/planEdit/PlanEditMainCard.vue';
import PlanEditSettingsCard from '@/views/journals/planEdit/PlanEditSettingsCard.vue';
import {mapActions, mapMutations, mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';
import PlanEditTabs from '@/views/journals/planEdit/planEditTabs/PlanEditTabs.vue';
import {Route} from 'vue-router';
import CConfirmDialog from '@/components/base/dialog/CConfirmDialog.vue';

Component.registerHooks(['beforeRouteUpdate', 'beforeRouteLeave']);
@Component({
    components: {
        CConfirmDialog,
        PlanEditTabs,
        PlanEditMainCard,
        PlanEditSettingsCard,
    },
    computed: {
        ...mapState('planEdit', ['planEdit', 'loading', 'hasUnsavedChanges']),
    },
    methods: {
        ...mapActions('planEdit', ['init', 'clearSolveProgressTimer']),
        ...mapMutations('planEdit', {
            setHasUnsavedChanges: 'setHasUnsavedChanges',
            clearPlanEditState: 'clearState',
        }),
        ...mapMutations('planEditResult', {
            clearPlanEditResultState: 'clearState',
        }),
    },
})
export default class PlanEdit extends Vue {
    @Prop() externalData!: string;
    @Prop() idPlan!: number;

    public planEdit!: PlanEditModel | null;
    public loading!: boolean;
    public hasUnsavedChanges!: boolean;
    public init!: Function;
    public clearSolveProgressTimer!: Function;
    public setHasUnsavedChanges!: Function;
    public clearPlanEditState!: Function;
    public clearPlanEditResultState!: Function;

    async created() {
        this.$root.$on('plan_edit:unsaved_changes', this.setHasUnsavedChanges);
        await this.init({
            externalData: this.externalData,
            id: this.idPlan,
            needCopy: !!this.$route.query.needCopy,
        });
        if (this.$route.query.needCopy)
            this.$router
                .replace({
                    params: {idPlan: String(this.planEdit?.Id)},
                })
                .catch(() => {});
    }

    beforeDestroy() {
        this.clearSolveProgressTimer();
    }

    beforeRouteUpdate(to: Route, from: Route, next: Function) {
        if (this.hasUnsavedChanges)
            (this.$refs.confirm as any).open(
                {
                    text: 'У вас есть несохраненные изменения, вы уверены, что хотите перейти?',
                },
                {
                    callback: () => {
                        this.setHasUnsavedChanges(false);
                        this.$root.$emit('plan_edit:unsaved_changes:reset');
                        next();
                    },
                },
            );
        else next();
    }

    beforeRouteLeave(to: Route, from: Route, next: Function) {
        this.clearPlanEditState();
        this.clearPlanEditResultState();
        next();
    }
}
